import React from 'react'
import './Card.scss'

export default function Card(props) {
  var header

  if (props.heading) {
    header = <div className="card-divider">{props.heading}</div>
  }

  return (
    <div className={`card ${props.width}`}>
      {header}
      <div className="card-section">{props.children}</div>
    </div>
  )
}
